const Sentry = require('@sentry/nextjs')

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
	environment: process.env.NEXT_PUBLIC_VERCEL_ENV
		? `vercel-${process.env.NEXT_PUBLIC_VERCEL_ENV}`
		: undefined,
})
